import { CheckCircle2 } from "lucide-react";

export default function ThankYou({ heading = "Thank you — we've received your message.", body, testId = "thank-you" }) {
  return (
    <div
      className="rounded-lg border border-emerald-200 bg-emerald-50 p-6"
      role="status"
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        <CheckCircle2 className="mt-0.5 shrink-0 text-emerald-600" size={22} aria-hidden="true" />
        <div>
          <h3 className="font-heading text-lg font-semibold text-emerald-900">{heading}</h3>
          <p className="mt-1 text-sm leading-relaxed text-emerald-900/85">
            {body || "A team member will follow up shortly during business hours (Mon–Fri, 9:00 AM – 5:00 PM). If your matter is time-sensitive, please call (902) 706-6287."}
          </p>
        </div>
      </div>
    </div>
  );
}
